import React, { useState, useEffect, use } from "react";
import "../Orders/Orders.css";
import "../Inventory/Inventory.css";
import Dropdown from "react-bootstrap/Dropdown";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import productImg from "../../../assets/images/State-Distributor/inventoryProduct.png";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik, useFormik } from "formik";
import { axiosInstance } from "../../../axiosInstance";
import TablePagination from "@mui/material/TablePagination";
import { IoClose } from "react-icons/io5";
import { GoSearch } from "react-icons/go";

export const SubOrders = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [orderList, setOrderList] = useState({});
  const [viewOrder, setViewOrder] = useState({});
  // view modal
  const [viewshow, setViewShow] = useState(false);

  const handleViewClose = () => setViewShow(false);
  const handleViewShow = (id) => {
    setViewShow(true);
    viewOrderDetails(id);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalCount, setTotalCount] = useState(0);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0); // reset to first page
  };

  // Filters
  const [filterToggler, setFilterToggler] = useState("");
  const [searchText, setSearchText] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [status, setStatus] = useState("");
  const [selectedLabel, setSelectedLabel] = useState("");
  const [show, setShow] = useState(false);

  // Convert YYYY-MM-DD → DD-MM-YYYY
  // function convertDateToDDMMYYYY(dateString) {
  //   if (!dateString) return "";
  //   const [year, month, day] = dateString.split("-");
  //   return `${day}-${month}-${year}`;
  // }

  async function FetchOrdersList() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: page + 1, // atleast 1 page
          page_size: rowsPerPage,
          search: searchText,
          payment_type: paymentType,
          status: status,
          date: selectedLabel,
        },
      };
      const response = await axiosInstance.get(
        "subdistributor/order-list/",
        config,
      );
      if (response.data.status === "Success" || response.status === 200) {
        setOrderList(response.data.data);
        setTotalCount(response.data?.data.count);
        console.log("Orders Data:", response.data.data);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to fetch order list");
      console.log("Failed to fetch order list");
    } finally {
      setLoading(false);
    }
  }
  // useEffect(() => {
  //   FetchOrdersList();
  // }, [page, rowsPerPage]);

  // async function FetchOrdersList() {
  //   try {
  //     setLoading(true);

  //     const params = {
  //       page: page + 1,
  //       page_size: rowsPerPage,
  //     };

  //     // SEARCH — Either order_id or customer/subdistributor name
  //     if (searchText) {
  //       if (!isNaN(searchText)) params.order_id = searchText;
  //       else params.subdistributor_name = searchText;
  //     }

  //     // PAYMENT TYPE
  //     if (paymentType) params.payment_type = paymentType.toLowerCase();

  //     // STATUS
  //     if (status) params.status = status.toLowerCase();

  //     // DATE
  //     if (selectedLabel) {
  //       if (!isNaN(selectedLabel)) params.date = selectedLabel; // 7, 15, 30
  //       else params.date = convertDateToDDMMYYYY(selectedLabel); // custom date
  //     }

  //     const response = await axiosInstance.get("subdistributor/order-list/", {
  //       params,
  //     });

  //     if (response.data.status === "Success" || response.status === 200) {
  //       setOrderList(response.data.data);
  //       setTotalCount(response.data.data.count);
  //     }
  //   } catch (error) {
  //     toast.error(
  //       error.response?.data?.message || "Failed to fetch order list"
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // }

  useEffect(() => {
    FetchOrdersList();
  }, [page, rowsPerPage]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (page !== 0) {
        setPage(0);
      } else {
        FetchOrdersList();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchText, paymentType, status, selectedLabel]);

  // CLEAR ALL FILTERS
  function handleClearFilters() {
    setSearchText("");
    setFilterToggler("");
    setPaymentType("");
    setStatus("");
    setSelectedLabel("");
  }

  // RESET search
  function handleReset() {
    setSearchText("");
  }

  async function viewOrderDetails(id) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/subdistributor/order/${id}/`);
      if (response.data.status === "Success" || response.status === 200) {
        setViewOrder(response.data.data);
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "failed to fetch order details!",
      );
      console.log("failed to fetch order details!");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="ordersContainer">
        <div className="container">
          <div className="dashboardTitleContainer">
            <div>
              <div className="inventoryTitle">Orders</div>
              <div className="inventorySubtitle">
                Request new stock, track ongoing orders, and update received
                stock here.
              </div>
            </div>
            <div className="addButtonContainer">
              <div className="inventoryBtnReorder">
                {/* <button onClick={() => navigate("/sub-orders-reorder")}>
                  Re-Order
                </button> */}
                <button onClick={() => navigate("/sub-orders-reorder")}>
                  Self Order
                </button>
              </div>
              <div className="inventoryBtnNewOrder">
                <button onClick={() => navigate("/sub-create-order")}>
                  New Order
                </button>
              </div>

              {/* <div className="inventoryBtnIncome">
                <button onClick={() => navigate("/sub-orders-addIncomeStock")}>
                  Add Incoming Stock
                </button>
              </div> */}
            </div>
          </div>

          <div className="searchMainContainer">
            <div className="searchSubContainer">
              <div className="searchGrid">
                <div>
                  <input
                    type="text"
                    placeholder="Search by Order Id"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                <div style={{ display: "flex", gap: "5px" }}>
                  <div>
                    <GoSearch className="searchIcon" />
                  </div>
                  <div className="btnRestSearch">
                    <button onClick={handleReset}>Reset</button>
                  </div>
                </div>
              </div>
              <div>
                <div className="dropdownTitle">Filter by</div>
                <Dropdown className="nestedDropdown">
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {filterToggler || "All"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => {
                        setFilterToggler("");
                        setPaymentType("");
                        setStatus("");
                      }}
                    >
                      All
                    </Dropdown.Item>

                    {/* Payment Type with submenu */}
                    <div className="submenu-container">
                      <Dropdown.Item className="has-submenu">
                        Payment Type ▸
                      </Dropdown.Item>

                      <div className="submenu">
                        <Dropdown.Item
                          onClick={() => {
                            setFilterToggler("Debit");
                            setPaymentType("debit");
                            setStatus("");
                          }}
                        >
                          Debit
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            setFilterToggler("Credit");
                            setPaymentType("credit");
                            setStatus("");
                          }}
                        >
                          Credit
                        </Dropdown.Item>
                      </div>
                    </div>

                    {/* status with submenu */}
                    <div className="submenu-container">
                      <Dropdown.Item className="has-submenu">
                        Status ▸
                      </Dropdown.Item>

                      <div className="submenu">
                        <Dropdown.Item
                          onClick={() => {
                            setFilterToggler("Approved");
                            setStatus("approved");
                            setPaymentType("");
                          }}
                        >
                          Approved
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            setFilterToggler("Pending");
                            setStatus("pending");
                            setPaymentType("");
                          }}
                        >
                          Pending
                        </Dropdown.Item>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div>
                <div className="dropdownTitle">Date Range</div>
                <Dropdown show={show} onToggle={() => setShow(!show)}>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {selectedLabel || "Select"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu customDateMenu">
                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("7");
                      }}
                    >
                      Last 7 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("15");
                      }}
                    >
                      Last 15 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("30");
                      }}
                    >
                      Last 30 days
                    </Dropdown.Item>

                    <Dropdown.Item disabled>Custom Date :</Dropdown.Item>

                    <Dropdown.Item
                      as="div"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        type="date"
                        className="form-control"
                        onChange={(e) => {
                          setShow(false); // close after selecting
                          setSelectedLabel(e.target.value);
                        }}
                      />
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>

          {(filterToggler || selectedLabel || searchText) && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of:
                </span>

                {searchText && (
                  <>
                    {" "}
                    &nbsp; <strong>Search:</strong> {searchText}{" "}
                  </>
                )}

                {paymentType && (
                  <>
                    {" "}
                    , <strong>Payment:</strong> {paymentType}{" "}
                  </>
                )}

                {status && (
                  <>
                    {" "}
                    , <strong>Status:</strong> {status}{" "}
                  </>
                )}

                {selectedLabel && (
                  <>
                    {" "}
                    , <strong>Date:</strong> {selectedLabel}{" "}
                  </>
                )}
              </div>

              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearFilters}
              >
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )}
          {/* cards section  */}
          <div className="OrdersCardsGrid mt-4">
            <div className="inventoryCard">
              <div>Pending Orders</div>
              <div>
                {orderList?.order_card?.pending_orders
                  ? orderList?.order_card?.pending_orders
                  : "0"}
              </div>
            </div>
            <div className="inventoryCard">
              <div>In Transit Orders</div>
              <div>
                {orderList?.order_card?.in_transit
                  ? orderList?.order_card?.in_transit
                  : "0"}
              </div>
            </div>
            <div className="inventoryCard">
              <div>Completed Orders</div>
              <div>
                {orderList?.order_card?.completed_order
                  ? orderList?.order_card?.completed_order
                  : "0"}
              </div>
            </div>
            <div className="inventoryCard">
              <div>Total Ordered Value</div>
              <div>
                {orderList?.order_card?.total_orders
                  ? orderList?.order_card?.total_orders
                  : "0"}
              </div>
            </div>
          </div>

          {/* table  */}
          <div className="titleOrderList">Recent Orders</div>

          <div className="dashboardTableContainer">
            <TableContainer component={Paper}>
              <Table
                // sx={{ minWidth: 650 }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell align="left">Order ID</TableCell>
                    <TableCell align="left">Order Date</TableCell>
                    <TableCell align="left">No. of Products</TableCell>
                    <TableCell align="left">Status</TableCell>

                    <TableCell align="left">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orderList?.results?.length > 0 ? (
                    orderList?.results?.map((row) => (
                      <TableRow
                        key={row.order_id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className="dashboardTableBody"
                      >
                        <TableCell align="left">{row.order_id}</TableCell>
                        <TableCell align="left">{row.order_date}</TableCell>
                        <TableCell align="left">{row.no_of_products}</TableCell>
                        <TableCell
                          align="left"
                          style={{
                            color: (() => {
                              switch (row.status) {
                                case "Pending":
                                  return "#EF4444";
                                // case "Approved":
                                //   return "#45614C";
                                case "In Transit":
                                  return "#F59E0B";
                                case "Delivered":
                                  return "#10B981";
                                default:
                                  return "var(--color-font-secondary)";
                              }
                            })(),
                          }}
                        >
                          {row.status}
                        </TableCell>

                        <TableCell align="left">
                          <button
                            className="btnTableView"
                            onClick={() => {
                              handleViewShow(row.order_id);
                            }}
                          >
                            View
                          </button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        align="center"
                        style={{ padding: "20px" }}
                      >
                        No orders available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={totalCount}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 50]} //dropdown
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
          {/* view modal  */}

          <Modal
            show={viewshow}
            onHide={handleViewClose}
            centered
            className="viewOrderModal"
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>#ORD-{viewOrder?.order_date}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="orderModalGrid">
                <div className="orderModalContent">
                  <div>Order ID</div>
                  <div>{viewOrder?.order_id}</div>
                </div>
                <div className="orderModalContent">
                  <div>Order Date</div>
                  <div>{viewOrder?.order_date}</div>
                </div>
                <div className="orderModalContent">
                  <div>Status</div>
                  <div>{viewOrder?.status}</div>
                </div>
              </div>
              {/* table   */}
              <div className="orderModalTableTitle">Ordered Products</div>

              <div className="dashboardTableContainer">
                <TableContainer component={Paper}>
                  <Table
                    // sx={{ minWidth: 650 }}
                    stickyHeader
                    aria-label="sticky table"
                  >
                    <TableHead className="dashboadTableHeader">
                      <TableRow>
                        <TableCell align="left">Product Image</TableCell>
                        <TableCell align="left">Product Name</TableCell>
                        <TableCell align="left">Quantity Ordered</TableCell>
                        <TableCell align="left">Unit Price (₹)</TableCell>

                        <TableCell align="left">Total (₹)</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {viewOrder.products?.length > 0 ? (
                        viewOrder.products.map((row) => (
                          <TableRow
                            key={row.name}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                            className="dashboardTableBody"
                          >
                            <TableCell align="left">
                              <span className="productImg">
                                <img
                                  src={
                                    row.product_image
                                      ? row.product_image
                                      : productImg
                                  }
                                />
                              </span>
                            </TableCell>
                            <TableCell align="left">
                              {row.product_name}
                            </TableCell>
                            <TableCell align="left">{row.qty}</TableCell>
                            <TableCell align="left">{row.price}</TableCell>
                            <TableCell align="left">{row.total}</TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={5}
                            align="center"
                            style={{ padding: "20px" }}
                          >
                            Data not available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
};
